<template>
  <b-modal
    id="feedback-modal"
    :visible="visible"
    :title="$t('feedbackModal.title')"
    hide-footer
    centered
    @hidden="onHidden"
  >
    <div v-if="sent" class="text-center py-4">
      <p class="feedback-success mb-1">{{ $t('feedbackModal.success') }}</p>
      <b-button variant="success" class="mt-3" @click="visible = false">
        {{ $t('feedbackModal.close') }}
      </b-button>
    </div>
    <b-form v-else @submit.prevent="submit">
      <b-form-group :label="$t('feedbackModal.messageLabel')" label-for="feedback-message">
        <b-form-textarea
          id="feedback-message"
          v-model="message"
          :placeholder="$t('feedbackModal.messagePlaceholder')"
          rows="5"
          max-rows="10"
          required
        />
      </b-form-group>
      <p v-if="error" class="feedback-error small">{{ $t('feedbackModal.error') }}</p>
      <div class="text-right">
        <b-button
          type="submit"
          variant="success"
          :disabled="sending || !message.trim()"
        >
          <b-spinner v-if="sending" small class="mr-1" />
          {{ $t('feedbackModal.send') }}
        </b-button>
      </div>
    </b-form>
  </b-modal>
</template>

<script>
import SendFeedbackEmail from '@/graphQlQueries/mutations/sendFeedbackEmail';

const FEEDBACK_RECIPIENT = 'support@webmag.io';

function escapeHtml(value) {
  return String(value)
    .replace(/&/g, '&amp;')
    .replace(/</g, '&lt;')
    .replace(/>/g, '&gt;');
}

export default {
  name: 'ModalFeedback',
  props: {
    userObject: { type: Object, required: true },
  },
  data() {
    return {
      visible: false,
      message: '',
      sending: false,
      sent: false,
      error: false,
    };
  },
  created() {
    // opened from anywhere in the app (news modal footer, header dropdown)
    this.$root.$on('webmag:open-feedback', this.open);
  },
  beforeDestroy() {
    this.$root.$off('webmag:open-feedback', this.open);
  },
  methods: {
    open() {
      this.message = '';
      this.sending = false;
      this.sent = false;
      this.error = false;
      this.visible = true;
    },
    onHidden() {
      this.visible = false;
    },
    submit() {
      if (!this.message.trim() || this.sending) return;
      this.sending = true;
      this.error = false;
      const lines = [
        `Nachricht:\n${this.message.trim()}`,
        `Von: ${this.userObject.name || '-'} (${this.userObject.email})`,
        `Seite: ${window.location.href}`,
      ];
      const html = [
        `<p><strong>Nachricht:</strong><br>${escapeHtml(this.message.trim()).replace(/\n/g, '<br>')}</p>`,
        `<p><strong>Von:</strong> ${escapeHtml(this.userObject.name || '-')} (${escapeHtml(this.userObject.email)})</p>`,
        `<p><strong>Seite:</strong> ${escapeHtml(window.location.href)}</p>`,
      ].join('\n');
      this.$apollo.mutate({
        mutation: SendFeedbackEmail,
        variables: {
          to: FEEDBACK_RECIPIENT,
          subject: 'Feedback aus der Webmag-App',
          text: lines.join('\n\n'),
          html,
        },
      }).then(() => {
        this.sending = false;
        this.sent = true;
      }).catch(() => {
        this.sending = false;
        this.error = true;
      });
    },
  },
};
</script>

<style scoped lang="scss">
// the global _modal.scss zeroes .modal-body padding for all dialogs
::v-deep .modal-body {
  padding: 24px 32px;
}

::v-deep label {
  font-weight: 600;
  color: #44484c;
}

.feedback-success {
  font-size: 16px;
  color: #35393e;
}

.feedback-error {
  color: #dc3545;
}
</style>
